import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { HERO_BANNERS } from "../mock";

const Hero = () => {
  const [i, setI] = useState(0);
  const banner = HERO_BANNERS[i];

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % HERO_BANNERS.length), 7000);
    return () => clearInterval(t);
  }, []);

  const onCta = () => {
    const id = banner.href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full h-[78vh] min-h-[560px] overflow-hidden bg-stone-100">
      {HERO_BANNERS.map((b, idx) => (
        <div
          key={b.id}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: idx === i ? 1 : 0 }}
        >
          <img
            src={b.image}
            alt={b.title}
            className="absolute inset-0 w-full h-full object-cover"
            style={{ transform: idx === i ? "scale(1.05)" : "scale(1)", transition: "transform 8s ease" }}
          />
          <div className="absolute inset-0 hero-gradient" />
        </div>
      ))}

      <div className="relative z-10 max-w-[1400px] mx-auto h-full px-6 lg:px-10 flex items-center">
        <div className="max-w-xl">
          <div className="text-[12px] tracking-[0.35em] text-stone-600 uppercase mb-3">
            {banner.eyebrow}
          </div>
          <h1 className="font-serif-display text-stone-900 text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] mb-5">
            {banner.title}
          </h1>
          <p className="text-stone-700 text-base md:text-lg leading-relaxed mb-8 max-w-md">
            {banner.description}
          </p>
          <button onClick={onCta} className="btn-primary">
            {banner.cta}
          </button>
        </div>
      </div>

      <div className="absolute z-20 inset-y-0 left-0 flex items-center pl-3 md:pl-6">
        <button
          onClick={() => setI((p) => (p - 1 + HERO_BANNERS.length) % HERO_BANNERS.length)}
          className="w-10 h-10 rounded-full bg-white/80 hover:bg-white text-stone-800 flex items-center justify-center shadow"
          aria-label="Previous"
        >
          <ChevronLeft size={20} />
        </button>
      </div>
      <div className="absolute z-20 inset-y-0 right-0 flex items-center pr-3 md:pr-6">
        <button
          onClick={() => setI((p) => (p + 1) % HERO_BANNERS.length)}
          className="w-10 h-10 rounded-full bg-white/80 hover:bg-white text-stone-800 flex items-center justify-center shadow"
          aria-label="Next"
        >
          <ChevronRight size={20} />
        </button>
      </div>

      <div className="absolute z-20 bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {HERO_BANNERS.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setI(idx)}
            className={`h-1.5 rounded-full transition-all ${
              idx === i ? "bg-[#c8232c] w-8" : "bg-stone-300 w-3"
            }`}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
